export function Play() {
  return (
    <path
      d="M10 20V9.68454C10 8.92548 10.8125 8.44317 11.4789 8.80665L30.3905 19.1221C31.0854 19.5011 31.0854 20.4989 30.3905 20.8779L11.4789 31.1934C10.8125 31.5568 10 31.0745 10 30.3155V20Z"
      fill="currentColor"
    />
  )
}
